// extracted by mini-css-extract-plugin
module.exports = {"recall":"page_recall__Eenqp"};